/* sb-pdp-v3-sticky.js — the Atlas v3 page-level sticky buy bar
 * (theme/sections/sb-pdp-sticky-atc-uk-v1.liquid, ADR 0635 / S7).
 *
 * Reveals the fixed sticky bar once the in-page hero ATC scrolls out of view,
 * mirrors the hero's live title / price / compare-at / save badge into the bar,
 * and routes the bar's Add-to-cart through the hero's own ATC. All state is read
 * FROM the v3 hero — the bar has no price of its own.
 *
 * Dedicated to the v3 markup per the reskinned-section-shared-js-silent-noop
 * skill. Without a `[data-sticky-atc]` bar it still keeps the final close in
 * sync with the selected hero tier, then stops. With no `.sec-hero-buybox` it
 * remains a complete no-op (a v2 PDP). The behavioural contract (proven by
 * Playwright) is that a present bar is HIDDEN at the top of the page and
 * VISIBLE after scrolling past the in-page buy box.
 */
(function () {
  'use strict';

  var ACTIVE = 'sec-sticky-atc--active';

  function copyText(fromRoot, fromSel, toRoot, toSel) {
    var src = fromRoot.querySelector(fromSel);
    var dst = toRoot.querySelector(toSel);
    if (dst) dst.textContent = src ? src.textContent.trim() : '';
  }

  function boot() {
    var bar = document.querySelector('[data-sticky-atc]');
    var hero = document.querySelector('.sec-hero-buybox');
    if (!hero) return; // v2 PDP or no hero — leave the bar hidden.

    var atc = hero.querySelector('.sec-hero-buybox__atc');
    var anchor = atc || hero;
    var heroForm = hero.querySelector('form[action*="/cart/add"]') || hero.querySelector('form');

    // Mirror the hero title once.
    var heroTitle = hero.querySelector('.sec-hero-buybox__title');
    var barTitle = bar ? bar.querySelector('[data-sticky-title]') : null;
    if (heroTitle && barTitle) barTitle.textContent = heroTitle.textContent.trim();

    // Keep the close coherent with the product-specific hero action. The
    // sticky bar still submits through the hero form; it only mirrors its
    // visible label (for example, Renomi's "Start my routine").
    var heroAtcLabel = hero.querySelector('.sec-hero-buybox__atc-label');
    var barAddLabel = bar ? bar.querySelector('[data-sticky-add]') : null;
    if (heroAtcLabel && barAddLabel)
      barAddLabel.textContent = heroAtcLabel.textContent.trim();

    // Mirror the price lockup now + whenever the hero tier changes.
    function syncPrice() {
      // Some reviewed product routes intentionally remove the repeated price
      // from the visible CTA and suppress the separate hero price lockup. The
      // selected tier radio still owns the live, variant-derived display price,
      // so use it as the fallback source for the sticky and final close.
      var heroNow = hero.querySelector('[data-hb-price]');
      var selectedTier = hero.querySelector('input[name="sb_tier"]:checked');
      var selectedPrice = selectedTier ? selectedTier.dataset.price || '' : '';
      var priceText = heroNow ? heroNow.textContent.trim() : selectedPrice;
      var barNow = bar ? bar.querySelector('[data-sticky-now]') : null;
      if (barNow) barNow.textContent = priceText;
      var heroCompare = hero.querySelector('[data-hb-compare]');
      var barWas = bar ? bar.querySelector('[data-sticky-was]') : null;
      if (barWas) {
        var showCompare =
          heroCompare &&
          heroCompare.style.display !== 'none' &&
          heroCompare.textContent.trim().length > 0;
        barWas.textContent = showCompare ? heroCompare.textContent.trim() : '';
      }
      var heroSave = hero.querySelector('[data-hb-save]');
      var barBadge = bar ? bar.querySelector('[data-sticky-badge]') : null;
      if (barBadge) {
        var showSave =
          heroSave &&
          heroSave.style.display !== 'none' &&
          heroSave.textContent.trim().length > 0;
        barBadge.textContent = showSave ? heroSave.textContent.trim() : '';
        barBadge.style.display = showSave ? '' : 'none';
      }

      // The final CTA's server-rendered price echo (from the DEFAULT tier)
      // mirrors the hero's live selection too, so the close never shows a
      // price the shopper has already changed away from.
      var echoNow = document.querySelector('[data-final-echo-now]');
      if (echoNow) echoNow.textContent = priceText;
      var echoWas = document.querySelector('[data-final-echo-was]');
      if (echoWas) {
        var heroCompareForEcho = hero.querySelector('[data-hb-compare]');
        var showEchoCompare =
          heroCompareForEcho &&
          heroCompareForEcho.style.display !== 'none' &&
          heroCompareForEcho.textContent.trim().length > 0;
        echoWas.textContent = showEchoCompare
          ? heroCompareForEcho.textContent.trim()
          : '';
      }
    }
    syncPrice();
    var tiers = hero.querySelectorAll('input[name="sb_tier"]');
    for (var i = 0; i < tiers.length; i++) {
      tiers[i].addEventListener('change', function () {
        // The hero's own handler runs on the same event; re-read after it.
        setTimeout(syncPrice, 0);
      });
    }

    // Some lean PDP routes intentionally omit the page-level sticky bar. The
    // selected tier still needs to update the final offer close above.
    if (!bar) return;

    // Add-to-cart -> trigger the hero ATC (or submit the hero form).
    var add = bar.querySelector('[data-sticky-add]');
    if (add)
      add.addEventListener('click', function (e) {
        e.preventDefault();
        if (atc) {
          atc.click();
        } else if (heroForm && typeof heroForm.requestSubmit === 'function') {
          heroForm.requestSubmit();
        }
      });

    // Dismiss (mobile).
    var close = bar.querySelector('[data-sticky-close]');
    var dismissed = false;
    if (close)
      close.addEventListener('click', function () {
        dismissed = true;
        bar.classList.remove(ACTIVE);
      });

    // Reveal once the in-page ATC has scrolled fully above the viewport.
    function onScroll() {
      if (dismissed) return;
      var past = anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle(ACTIVE, past);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
